export default __webpack_public_path__ + "static/anuMehta-7e426ec07e73e42fc5715a5812b1eb1b.jpg";